import { apiClient } from './client';

export type VideoLessonType = 'practical' | 'theoritical' | 'other';

export interface VideoLesson {
  id: string;
  sort_id: number;
  title: string;
  description: string | null;
  type: VideoLessonType;
  url: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateVideoLessonDto {
  sort_id: number;
  title: string;
  description?: string | null;
  type: VideoLessonType;
  url: string;
  is_active?: boolean;
}

export interface UpdateVideoLessonDto extends Partial<CreateVideoLessonDto> {}

export const videoLessonsApi = {
  /**
   * Все уроки, включая выключенные. Публичный `/video-lessons` отдаёт только
   * активные — им пользуется приложение.
   */
  getAll: async (): Promise<VideoLesson[]> => {
    const response = await apiClient.get<VideoLesson[]>('/video-lessons/admin/all');
    return response.data;
  },

  getById: async (id: string): Promise<VideoLesson> => {
    const response = await apiClient.get<VideoLesson>(`/video-lessons/${id}`);
    return response.data;
  },

  create: async (dto: CreateVideoLessonDto): Promise<VideoLesson> => {
    const response = await apiClient.post<VideoLesson>('/video-lessons', dto);
    return response.data;
  },

  update: async (id: string, dto: UpdateVideoLessonDto): Promise<VideoLesson> => {
    const response = await apiClient.patch<VideoLesson>(`/video-lessons/${id}`, dto);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/video-lessons/${id}`);
  },
};
